<template>
    <transition name="fade">
        <component
                :is="activeStep"
                :activeStep="activeStep"
                :activeStepIndex="activeIndex"
                @previousStep="previousStep"
                @nextStep="nextStep"
                @goToStep="goToStep"
        />
    </transition>
</template>

<script>

import { store } from '@/store/dataStore'
import TypeStep from "@/components/steps/TypeStep";
import DataStep from "@/components/steps/DataStep";
import InfoStep from "@/components/steps/InfoStep";
import ConfirmStep from "@/components/steps/ConfirmStep";

export default {
    name: 'App',
    components: {
        TypeStep,
        DataStep,
        InfoStep,
        ConfirmStep,
    },
    data() {
        return {
            store,
            show: false,
            disabledState: false,
            activeStep: null,
            activeIndex: null,
            progressTabs: null,
        }
    },
    methods: {
        /**
         * Move on to the next step
         */
        nextStep() {
            const nextIndex = this.activeIndex + 1;
            this.activeStep = this.store.steps[nextIndex];
            this.activeIndex = nextIndex;
        },
        /**
         * Move back to the previous step
         */
        previousStep() {
            const previousIndex = this.activeIndex - 1;
            this.activeStep = this.store.steps[previousIndex];
            this.activeIndex = previousIndex;
        },
        /**
         * Move back to the previous step
         */
        goToStep(Index) {
            // Go tho the given step
            this.activeStep = this.store.steps[Index]
            this.activeIndex = Index;
        },
        /**
         * We clear the stepSettings
         */
        clearstepSettings() {
            this.stepSettings = null;
        }
    },
    mounted() {
        this.activeStep = this.store.steps[0];
    },
    created() {
        window.onbeforeunload = function (e) {
            e = e || window.event;
            //old browsers
            if (e) {e.returnValue = 'Bent u zeker dat u wilt vernieuwen? Alle ingegeven data gaat verloren.';}
            //safari, chrome(chrome ignores text)
            return 'Bent u zeker dat u wilt vernieuwen? Alle ingegeven data gaat verloren.';
        };
    }
}
</script>
